import { AcademicCapIcon, ArrowRightStartOnRectangleIcon, BookOpenIcon, ChartPieIcon, ChatBubbleOvalLeftEllipsisIcon, Cog8ToothIcon, DocumentCheckIcon, HomeIcon, InformationCircleIcon, TrophyIcon } from '@heroicons/vue/24/outline'

export interface AppNavLink {
  label?: string
  icon?: Component
  to?: string
  external?: boolean
  isStrict?: boolean
  testId?: string
  on?: Record<string, (event: MouseEvent) => void>
  shouldHighlight?: (currentPath: string) => boolean
}

export function useSupportModal() {
  return useState('liquidity:support-modal', () => false)
}

export const navMenu: AppNavLink[][] = [
  [
    {
      icon: HomeIcon,
      to: '/active-rfqs',
      label: 'Home & RFQs',
      shouldHighlight: (currentPath: string) => {
        return [
          'active-rfqs',
          'closed-rfqs',
          'summary',
          'round-1-my-quotes',
          'round-1-outcome',
          'round-2-my-quotes',
          'round-2-outcome',
          'quote-templates',
        ].some((url: string) => currentPath.endsWith(url))
      },
    },
    {
      icon: DocumentCheckIcon,
      label: 'My Active Engagements',
      to: '/my-active-engagements',
      shouldHighlight: (currentPath: string) => {
        return currentPath.startsWith('/my-active-engagements')
      },
    },
    {
      icon: ChartPieIcon,
      label: 'Monitor Active Engagements',
      to: '/monitor-active-engagements',
      isStrict: true,
    },
    {
      icon: TrophyIcon,
      label: 'Market Maker Leaderboard',
      to: '/market-maker-leaderboard',
    },
    {
      icon: BookOpenIcon,
      label: 'Reports History & API Keys',
      to: '/reports-history',
      shouldHighlight: (currentPath: string) => {
        return [
          'reports-history',
          'api-keys',
        ].some((url: string) => currentPath.endsWith(url))
      },
    },
    {
      icon: AcademicCapIcon,
      label: 'Forgd Academy',
      to: '/academy',
      testId: 'nav-academy',
      shouldHighlight: (currentPath: string) => {
        return currentPath.startsWith('/academy')
      },
    },
  ],
  [
    {
      icon: Cog8ToothIcon,
      label: 'Settings',
      to: '/settings',
      shouldHighlight: (currentPath: string) => {
        return [
          'settings',
        ].some((url: string) => currentPath.startsWith(url))
      },
    },
    {
      icon: InformationCircleIcon,
      to: 'https://www.forgd.com/about',
      label: 'About Forgd',
      external: true,
    },
    {
      icon: ChatBubbleOvalLeftEllipsisIcon,
      label: 'Support',
      on: {
        click: () => {
          useSupportModal().value = true
        },
      },
    },
    {
      icon: ArrowRightStartOnRectangleIcon,
      label: 'Logout',
      on: {
        click: logout,
      },
      testId: 'logout',
    },
  ],
]

export const liquidityNavTools = navMenu[0]!.map(item => ({
  label: item.label,
  to: item.to,
  icon: item.icon,
}))
